<section class="session-unavailable" role="main">
  <div class="session-unavailable__card">
    <nova-icon name="video_camera" size="medium" [ariaHidden]="true" />
    <h1>{{ 'session-unavailable.TITLE' | translate }}</h1>
    <p>{{ 'session-unavailable.MESSAGE' | translate }}</p>
    <p class="session-unavailable__hint">{{ 'session-unavailable.HINT' | translate }}</p>
    <a
      class="nova-link"
      href="tel:+18449131386"
      [attr.aria-label]="'session-unavailable.CALL_SUPPORT' | translate"
    >{{ phoneNumber }}</a>
  </div>
</section>
